// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"5a057b83","240":"2c6e6ece","489":"a4e1e71e","773":"2bb6d6c9","778":"c022dd87","803":"dd492fdc","982":"894450cf"}[chunkId] + ".chunk.js";
};